// extracted by mini-css-extract-plugin
export default {"checkbox-list":"checkboxList_checkbox-list__l2g7H"};